<div class="ribbon">
    <ogr-icon name="ticket" class="icono"></ogr-icon>
</div>
